const categories = [
  "総合満足度",
  "① 会社への共感",
  "② 労働時間管理・福利厚生",
  "③ 評価・処遇",
  "④ 給与",
  "⑤ 仕事の設計と配分",
  "⑥ 上司の管理・監督",
  "⑦ 同僚との関係",
  "⑧ 関連部署との関係",
  "⑨ 職場環境（物理的環境）",
  "⑩ 仕事の充実",
  "⑪ 仕事の負荷",
  "⑫ 顧客との関係",
  "⑬ 能力開発"
];
const colors = ["#CFE283", "#FFF280", "#EDA184"];

const makeColumnData = obj => ({
  name: obj.name,
  data: obj.data,
  type: "column",
  color: "#678ecc"
});

const makeLineData = datas =>
  datas.map((v, i) => ({
    name: v.name,
    data: v.data,
    type: "line",
    color: colors[i]
  }));

const MeasureSizeEachAttr = (columnData, lineData, title, classes) => ({
  credits: {
    enabled: false
  },
  chart: {
    height: 600
  },
  title,
  xAxis: {
    categories,
    className: classes.verticalWriting,
    crosshair: true,
    labels: {
      useHTML: true
    }
  },
  yAxis: {
    className: classes.verticalWriting,
    title: {
      text: "尺度の大きさ",
      rotation: 0,
      useHTML: true,
      x: 36
    },
    max: 100,
    tickInterval: 10,
    labels: {
      rotation: -90
    }
  },
  tooltip: {
    shared: true,
    backgroundColor: "#ffffff",
    outside: true
  },
  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "middle"
  },
  series: [makeColumnData(columnData), ...makeLineData(lineData)]
});

export default MeasureSizeEachAttr;



// WEBPACK FOOTER //
// ./src/models/MeasureSizeEachAttr.js